module.exports = __webpack_public_path__ + "img/hr-med.4d8e5bd4.png";